import script from "./Slasher.vue?vue&type=script&setup=true&lang=js"
export * from "./Slasher.vue?vue&type=script&setup=true&lang=js"

import "./Slasher.vue?vue&type=style&index=0&id=cf82ffde&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf82ffde"]])

export default __exports__